import { Platform } from 'react-native';

import {
    EpgProgram,
    MixedItem,
    PlaybackTypes,
    RBProgram,
    SearchProgram,
} from 'store/railsBuilder/reducer.types';

import getOpeningParams from 'utils/deeplinks/getOpeningParams';
import handleOpenDeeplink from 'utils/deeplinks/handleOpenDeeplink';

import {
    DeepLinkTriggered,
    ThirdPartyAppStartItem,
} from 'components/Ribbon/types';

import getDeepLinkProviderValues from './deeplinks/getDeepLinkProviderValues';

export type DeeplinkParams = {
    appleAppId: string;
    androidMobileBundleId: string;
};

export type LinkParams = DeeplinkParams & { appleBundleLink?: string };

export default async function openDeeplink(
    item: EpgProgram | RBProgram | MixedItem | SearchProgram,
    onDeepLinkTriggered?: (item: DeepLinkTriggered) => void,
    onThirdPartyAppStart?: (item: ThirdPartyAppStartItem) => void,
    playbackType?: PlaybackTypes | undefined,
) {
    const { appleAppId, androidMobileBundleId, link } = getOpeningParams(item);

    if (Platform.OS === 'android' && !androidMobileBundleId) {
        throw new Error('Android mobile bundle id not found!');
    }

    const { url } = link;

    const marketLink =
        Platform.OS === 'ios'
            ? `https://apps.apple.com/app/id${appleAppId}`
            : `https://play.google.com/store/apps/details?id=${androidMobileBundleId}`;

    const { deeplinkProviderId, providerResourceId } =
        getDeepLinkProviderValues(item);

    await handleOpenDeeplink({
        itemId: item.id,
        deepLinkid: item.id,
        onThirdPartyAppStart,
        onDeepLinkTriggered,
        deeplinkProviderId,
        providerResourceId,
        androidMobileBundleId,
        appleAppId,
        url,
        marketLink,
        playbackType,
    });
}
